import client from '@/lib/http-client';
import axios from 'axios';

const endpoint = '/medias';
const CancelToken = axios.CancelToken;

export default {
	/**
	 * File Upload
	 * @param {Object} params Params
	 * @param {File} params.fileUpload File to be uploaded
	 * @param {*} cb
	 * @param {*} errorCb
	 */
	upload(params, token, cb, errorCb, progressCallback, cancelCallback) {
		const url = '/upload';
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
			onUploadProgress: (progressEvent) => {
				const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
				if (progressCallback) progressCallback(percentCompleted);
			},
			cancelToken: new CancelToken(((c) => {
				// An executor function receives a cancel function as a parameter
				if (cancelCallback) {
					// eslint-disable-next-line no-param-reassign
					cancelCallback(c);
				}
			})),
		};
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		client.post(url, params, config)
			.then(responseHandler)
			.catch(errorHandler);
	},

	getList(params, token, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const url = endpoint;
		client.get(url, { headers, params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	create(params, token, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const url = `${endpoint}`;
		client.post(url, params, { headers })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Update
	update(id, params, token, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		client.put(url, params, { headers })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Delete
	delete(id, token, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		client.delete(url, { headers })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// get by url
	checkToken(rundownId, token, cb, errorCb) {
		const url = `${endpoint}/check/${rundownId}/${token}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
